module.exports = __webpack_public_path__ + "img/tesoreria.9a8280e6.png";